export const FORM_SCHEMA_VERSION = 1;
export const FORM_FIELD_TYPES = [
    { id: "short_text", label: "Văn bản ngắn" },
    { id: "long_text", label: "Đoạn văn" },
    { id: "email", label: "Email" },
    { id: "number", label: "Số" },
    { id: "single_choice", label: "Một lựa chọn" },
    { id: "multi_choice", label: "Nhiều lựa chọn" },
    { id: "dropdown", label: "Dropdown" },
    { id: "date", label: "Ngày" },
    { id: "rating", label: "Đánh giá (sao)" },
    { id: "section", label: "Tiêu đề section" },
    { id: "description", label: "Văn bản hướng dẫn" },
];
export function defaultFormSettings() {
    return {
        allow_dismiss: true,
        dismiss_label: "Để sau",
        submit_label: "Gửi",
        require_submit: false,
        show_until_submitted: true,
        one_response_per_user: true,
        show_on_routes: ["workplace", "messenger"],
        modal_size: "medium",
        show_frequency: "once_per_session",
    };
}
export function emptyFormDefinition(title = "Biểu mẫu mới") {
    return {
        schema_version: FORM_SCHEMA_VERSION,
        title,
        description: "",
        fields: [
            {
                id: "f_sample",
                type: "short_text",
                label: "Câu hỏi mẫu",
                required: true,
                placeholder: "Nhập câu trả lời",
            },
        ],
    };
}
export function newFieldId() {
    return "f_" + Math.random().toString(36).slice(2, 10);
}
export function createField(type) {
    const base = {
        id: newFieldId(),
        type,
        label: "",
        required: false,
    };
    if (type === "section") {
        base.label = "Tiêu đề section";
    }
    else if (type === "description") {
        base.label = "Văn bản hướng dẫn";
        base.content = "";
    }
    else if (["single_choice", "multi_choice", "dropdown"].includes(type)) {
        base.label = "Câu hỏi";
        base.options = [
            { id: "opt_1", label: "Lựa chọn 1" },
            { id: "opt_2", label: "Lựa chọn 2" },
        ];
    }
    else if (type === "rating") {
        base.label = "Mức độ hài lòng";
        base.max = 5;
    }
    else {
        base.label = "Câu hỏi";
        base.placeholder = "";
    }
    return base;
}
export const FORM_STATUS_LABELS = {
    draft: "Nháp",
    active: "Đang active",
    scheduled: "Đã lên lịch",
    paused: "Tạm dừng",
    expired: "Hết hạn",
    archived: "Lưu trữ",
};
export function fieldTypeLabel(type) {
    const found = FORM_FIELD_TYPES.find((t) => t.id === type);
    return found ? found.label : type;
}
export function formatFormDate(value) {
    if (!value)
        return "-";
    const d = new Date(String(value).replace(" ", "T"));
    if (Number.isNaN(d.getTime()))
        return String(value);
    return d.toLocaleString("vi-VN", { timeZone: "Asia/Ho_Chi_Minh" });
}
/** datetime-local input value from ISO/DB string (Asia/Ho_Chi_Minh display intent). */
export function toDatetimeLocalValue(value) {
    if (!value)
        return "";
    const d = new Date(String(value).replace(" ", "T"));
    if (Number.isNaN(d.getTime()))
        return "";
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
export function fromDatetimeLocalValue(value) {
    if (!value)
        return null;
    const d = new Date(value);
    if (Number.isNaN(d.getTime()))
        return null;
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:00`;
}
